module.exports = __webpack_public_path__ + "static/cursor-4d238263998f28225ef0b06f5ed1a8ca.png";